import { styled } from '@mui/material/styles';
import { Apps } from '@sparemin/blockhead';

export const PlatformIcon = styled(Apps)`
  justify-content: center;
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.palette.grey[700]};
`;
